export default __webpack_public_path__ + "cde7269.png";